import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router';

import { useUserDetails } from '@/hooks';
import SavedSearchesTab from './SavedSearchesTab';
import TemplatesTab from './TemplatesTab';
import { useSavedSearchesPage } from './useSavedSearchesPage';

export type { Auth0Snapshot } from './atoms';
export {
  searchColumnVisibilityAtom,
  searchCreatedByAtom,
  searchDescriptionAtom,
  searchNameAtom,
  searchPageNoAtom,
  searchPageSizeAtom,
  searchSortAtom,
  searchTabSelectionAtom,
  searchTemplateColumnVisibilityAtom,
  searchTemplateCreatedByAtom,
  searchTemplateDescriptionAtom,
  searchTemplateForCopyAtom,
  searchTemplateNameAtom,
  searchTemplatePageNoAtom,
  searchTemplatePageSizeAtom,
  searchTemplateSortAtom,
  searchTypeAtom,
} from './atoms';

export default function SavedSearchesPage() {
  const { data: userDetails } = useUserDetails();
  const page = useSavedSearchesPage();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{'List Manager - Search Library'}</title>
        <meta name="description" content={'List Manager - Search Library'} />
      </Helmet>

      <Container
        sx={{
          maxWidth: '1500px !important',
          padding: '2rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            minHeight: '37px',
          }}
        >
          <Typography component="h2" variant="h5">
            Search Library
          </Typography>
          {page.searchesTabSelection === 'Templates' &&
            userDetails?.userLevel === 'Principal Coordinator' && (
              <Button
                component={NavLink}
                variant="outlined"
                startIcon={<AddIcon />}
                to={'/template'}
              >
                Create template
              </Button>
            )}
        </Stack>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'flex-begin',
            gap: '1rem'
          }}>
          <Tabs
            value={page.searchesTabSelection}
            onChange={(_, newTabSelection) => {
              page.setSearchesTabSelection(newTabSelection);
            }}
          >
            <Tab label="Saved Searches" value={'Saved Searches'} />
            <Tab label="Templates" value={'Templates'} />
          </Tabs>
        </Box>

        {page.searchesTabSelection === 'Saved Searches' && <SavedSearchesTab {...page} />}
        {page.searchesTabSelection === 'Templates' && <TemplatesTab {...page} />}
      </Container>
    </>
  );
}
